/**
 * @generated SignedSource<<bb84c9d42eb30307a1f677a164d9f3b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type favouriteCell_directoryBaseV3_FavouriteCellOld_favouriteValueRef$data = {
  readonly __id: string;
  readonly isFavourite: boolean | null | undefined;
  readonly " $fragmentType": "favouriteCell_directoryBaseV3_FavouriteCellOld_favouriteValueRef";
};
export type favouriteCell_directoryBaseV3_FavouriteCellOld_favouriteValueRef$key = {
  readonly " $data"?: favouriteCell_directoryBaseV3_FavouriteCellOld_favouriteValueRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"favouriteCell_directoryBaseV3_FavouriteCellOld_favouriteValueRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "favouriteCell_directoryBaseV3_FavouriteCellOld_favouriteValueRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isFavourite"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraFavouriteValue"
};

(node as any).hash = "3afa8d49daf11383befe1aa23caf1f4d";

export default node;
